export class MapCateNameOrg {
    static readonly MAP_CATENAME = new Map([
    ['All','GENERAL'],
    ['Promotion','PROMOTION'],
    ['Joint','JOINT'],
    ['Point','POINT']
      ])
}